import { axiosInstance } from "./apiInstance";
import { setCustomerList } from "actions/customers";
import { setUser } from "actions/user";
import { reloadUser } from "utils/functions";
import * as urls from "./urls";

export const getCustomerList = (pageNo, filterVals, query, fetchAll) => {
	return (dispatch) => {
		return axiosInstance
			.get(urls.getCustomerList, {
				params: {
					page: pageNo || undefined,
					all_records: fetchAll || undefined,
					q: query || undefined,
					...filterVals,
				},
			})
			.catch((err) => {
				if (err.response.status === 401) {
					reloadUser();
					dispatch(
						setUser({
							reAuth: false,
							showReAuthModal: false,
							requestType: "get",
						})
					);
					window.location.reload();
				}
				throw err;
			})
			.then((response) => {
				if (response.status === 200) {
					dispatch(setCustomerList(response.data));
					return response.data;
				} else {
					let err = new Error(response.data.msg);
					throw err;
				}
			});
	};
};

export const addCustomer = (obj) => {
	let body = JSON.stringify(obj);
	return (dispatch) => {
		return axiosInstance
			.post(urls.addCustomer, body)
			.catch((err) => {
				if (err.response.status === 401) {
					reloadUser();
					dispatch(
						setUser({
							reAuth: true,
							showReAuthModal: true,
							requestType: "post",
						})
					);
				}
				throw err;
			})
			.then((response) => {
				if (response.status === 201) {
					return response.data;
				} else {
					let err = new Error(response.data.msg);
					throw err;
				}
			});
	};
};

export const deleteCustomer = (id) => {
	return (dispatch) => {
		return axiosInstance
			.delete(`/client/customer/${id}`)
			.catch((err) => {
				if (err.response.status === 401) {
					reloadUser();
					dispatch(
						setUser({
							reAuth: true,
							showReAuthModal: true,
							requestType: "delete",
						})
					);
				}
				throw err;
			})
			.then((response) => {
				if (response.status === 204) {
					return true;
				} else {
					let err = new Error(response.data.msg);
					throw err;
				}
			});
	};
};
